import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';

import { Alert, Box, Button, Cards, Checkbox, Container, ExpandableSection, Form, FormField, Input, Link, List, Multiselect, Select, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlert } from '@mdi/js';
import { Icon } from '@mdi/react';

import "../../../../../components/css/CardStyles.css";
//import '../../components/css/override.css';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Confirm from '../../../../../components/extras/Confirm';
import Favorites from '../../../../../components/extras/Favorites';
import HorizontalRule from '../../../../../components/HorizontalRule';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnWarn, ItemEquipment, ItemPoll, ItemPollQuestion } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
interface EquipmentGroup {
  idCategory: number;
  category: string;
  equipments: ItemEquipment[];
}
interface ValidationResult {
  isValid: boolean;
  errors: { idQuestion: number; message: string }[];
}
export const MembersEtcPollsPage = () => {
  const { data, menu, idUser } = useGlobalState();




  const [polls, setPolls] = useState<ItemPoll[]>([]);
  const [pollsPrev, setPollsPrev] = useState<ItemPoll[]>([]);
  const [pollsActual, setPollsActual] = useState<ItemPoll[]>([]);
  const [pollsFuture, setPollsFuture] = useState<ItemPoll[]>([]);

  const [poll, setPoll] = useState<ItemPoll | null>(null);
  const [pollDelete, setPollDelete] = useState<ItemPoll | null>(null);

  const [idPoll, setIdPoll] = useState<number>(0);
  const [isValidAnswers, setIsValidAnswers] = useState<ValidationResult>({ isValid: true, errors: [] });
  const [title, setTitle] = useState<string>("Inscripciones");
  const validatePoll = (pollData: any): ValidationResult => {
    const errors: { idQuestion: number; message: string }[] = [];

    pollData.questions.forEach((q: any) => {
      const params = q.questionParameters;
      const answerObj = q.answer;
      const rawAnswer = answerObj?.answer;

      // 1. Check if required
      if (params.required === 1) {
        if (rawAnswer === null || rawAnswer === undefined || rawAnswer === "") {
          errors.push({ idQuestion: q.idQuestion, message: "Se requiere la pregunta " + q.question });
          return; // Skip further checks for this question
        }
      }

      // 2. Validate Min/Max Length (for Arrays/Multiple Selection)
      // If minLength or maxLength is set (and not 0), we assume it's a multi-selection check
      if (params.minLength > 0 || params.maxLength > 0) {
        // Ensure we are working with an array for length checks
        const answerArray = Array.isArray(rawAnswer)
          ? rawAnswer
          : (rawAnswer ? [rawAnswer] : []);

        if (params.minLength > 0 && answerArray.length < params.minLength) {
          errors.push({
            idQuestion: q.idQuestion,
            message: `Se requieren al menos ${params.minLength} opción(es).`
          });
        }

        if (params.maxLength > 0 && answerArray.length > params.maxLength) {
          errors.push({
            idQuestion: q.idQuestion,
            message: `Se permiten como máximo ${params.maxLength} opción(es).`
          });
        }
      }

      // 3. Specific Number Validation (Optional but recommended)
      if (q.questionType === "NUMBER" && rawAnswer !== null) {
        if (isNaN(Number(rawAnswer))) {
          errors.push({ idQuestion: q.idQuestion, message: "Debe ser un número válido." });
        }
      }
    });

    return {
      isValid: errors.length === 0,
      errors
    };
  };
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) handleGetPoll(id ? parseInt(id) : 0);
      else {
        setPoll(undefined)
        handleGetPolls();
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleDeleteAnswers = async (id: number) => {
    try {
      setPoll(null)
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/polls/delete',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({ idPoll: id })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data && data.code === 0) {
        setPollDelete(undefined)
        handleGetPolls();

      }

    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally {
      setLoading(false);
    }
  };
  const handleGetPolls = async () => {
    try {
      setPoll(null)
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/polls/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          isActivePoll: 1,
          orderBy: "dateOpen",
          order: "desc",
          orderBy2: "dateStart",
          order2: "asc"

        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.polls) {
        //setPolls(data.polls);
        if (!data.polls || data.polls.length === 0) return;

        const prev: ItemPoll[] = [];
        const actual: ItemPoll[] = [];
        const future: ItemPoll[] = [];

        for (const poll of data.polls) {
          if (poll.hasEnded === 1) {
            prev.push(poll);
          } else if (poll.hasStarted === 1 && poll.hasEnded === 0) {
            actual.push(poll);
          } else if (poll.hasOpen === 1 && poll.hasStarted === 0) {
            future.push(poll);
          }
        }
        setPollsPrev(prev);
        setPollsActual(actual);
        setPollsFuture(future);
        //console.log(future)
      }

    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally {
      setLoading(false);
    }
  };


  const handleSubmitPoll = async () => {
    try {

      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/polls/submit',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify(
          poll
        )
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data) {
        if (data.code === 0) {
          window.location.hash = "#members/etc/polls"
          setPoll(undefined)
        }
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally {
      setLoading(false);
    }
  };
  const handleGetPoll = async (idPoll: number) => {
    try {

      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/polls/get',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          idPoll: idPoll,
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.poll) {
        if (data.poll.isActivePoll === 0) {
          window.location.hash = "#members/etc/polls"
        } else {
          setPoll(data.poll);
          setPolls([]);
        }
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (idPoll === 0) {
      setTitle("Inscripciones");
    } else {
      setTitle("Estado " + (poll ? poll.poll : ""));
    }
  }, [idPoll]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      setIdPoll(id ? parseInt(id) : 0);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {
    if (idPoll !== 0) {
      handleGetPoll(idPoll);
    }
  }, [idPoll]);
  useEffect(() => {
    handleGetPolls()
  }, []);

  const getPollTypeTitle = (pollType: string) => {

    switch (pollType) {
      case "POLL":
        return "Encuesta";
      case "INSCRIPTION":
        return "Inscripción";
      case "REGISTRATION":
        return "Registro";
      case "VOTING":
        return "Votación";
      default:
        return "Desconocido";
    }
  }

  const uniqueUserCount = useMemo(() => {
    if (!poll?.answers || !Array.isArray(poll.answers)) return 0;

    // 1. Extract all idUser values into a flat array
    const allUserIds = poll.answers.map(item => item.idUser);

    // 2. Pass them to a Set to strip out duplicates
    const uniqueUsers = new Set(allUserIds);

    // 3. Return the total size of unique entries
    return uniqueUsers.size;
  }, [poll?.answers]);
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1"
            description={
              (poll?.totalEnabled || 0) > 0 ? (
                <Link>Habilitados: {poll?.totalEnabled || 0} | Respuestas: {uniqueUserCount}</Link>
              ) : (
                "" // Or simply "" if you want it blank No hay usuarios habilitados
              )
            }
            info={<span key={`SP1${poll?.idPoll}`}>
              {poll?.publicResults === 1 && (
                <BadgeCustom color={poll.totalUsers === 0 ? "light" : "blue"}>{poll.totalUsers === 0 ? "Sin inscritos" : `Inscrito${poll.totalUsers > 1 ? "s" : ""}: ${poll.totalUsers}`}</BadgeCustom>
              )}
            </span>}
            actions={
              <SpaceBetween direction='horizontal' size='xs'>
                {/* 1. Conditional "Volver" Button */}
                {/* We use a React Fragment (<>) with a key if the condition is met */}
                {idPoll !== 0 && (
                  <div key={`volver-btn-${poll?.idPoll || 0}`}>
                    <Button variant="link" onClick={() => {
                      setPoll(null)
                      window.location.hash = '#members/etc/polls';
                    }}>Volver</Button>
                  </div>
                )}

                <Favorites key={`favorites-${poll?.idPoll || 0}`} />

              </SpaceBetween>
            }>
            {poll?.poll ? (
              <span dangerouslySetInnerHTML={{ __html: poll.poll.replace(/\n/g, "<br/>") }} />
            ) : (
              "Inscripciones"
            )}
          </Header>

          {poll && (

            <SpaceBetween size="s">

              {poll?.poll ? (
                <span dangerouslySetInnerHTML={{ __html: poll.description.replace(/\n/g, "<br/>") }} />
              ) : (
                ""
              )}
              {/**
              <div key={`PL${poll.idPoll}`}
                style={{ marginBottom: '16px' }}
                dangerouslySetInnerHTML={{
                  __html: poll.description.replace(/\n/g, "<br>"),
                }}
              />
               */}
              {poll.visibility === -1 && (
                <StatusIndicator type="info">La inscripción es <strong>privada</strong>, su nombre no se muestra en los <strong>resultados</strong></StatusIndicator>
              )}

              <Box variant="p">Fecha de cierre: {poll.dateClose} a las {poll.timeClose}</Box>
              <StatusIndicator type='info'>Sus respuestas pueden ser modificadas hasta la fecha de cierre</StatusIndicator>
              {poll.hasStarted === 0 && (
                <Alert type="info" header="Inscripción no iniciada" dismissible={false}>
                  La fecha de inicio de esta inscripción comienza el <strong>{poll.dateOpen}</strong> a las <strong>{poll.timeOpen}</strong>. Por favor, vuelve más tarde para participar.
                </Alert>
              )}
              {poll.hasEnded === 1 && (
                <Alert type="info" header="Inscripción finalizada" dismissible={false}>
                  La fecha de cierre de esta inscripción ha caducado. Gracias por tu interés en participar.
                </Alert>
              )}
              {poll.hasEnded === 0 && poll.hasOpen === 1 && poll.userCanAnswer === 0 && (
                <Alert
                  type="error"
                  header="Usuario no autorizado"
                >
                  Esta inscripción ha sido restringida a un tipo o grupo de usuario al cual usted no pertenece. En caso de discrepancia, por favor contactar a los administradores para más información.
                </Alert>
              )}

              {poll.hasEnded === 0 && poll.hasStarted === 1 && poll.userCanAnswer === 1 && (
                <Form actions={<SpaceBetween direction="vertical" size="xs">
                  <Button variant="primary" onClick={() => {
                    //console.log(poll)
                    const result = validatePoll(poll);
                    setIsValidAnswers(result);
                    if (result.isValid) {
                      handleSubmitPoll()
                    }
                  }}>{`Enviar respuesta${poll.questions.length > 1 ? "s" : ""}`}</Button>
                </SpaceBetween>
                }>
                  <SpaceBetween size="l" direction='vertical'>

                    {poll.questions.map((question, index) => (
                      //<React.Fragment key={question.idQuestion ?? index}>
                      <Container key={question.idQuestion ?? index}>

                        {question.visibilityQuestion === -1 && (
                          <StatusIndicator type="info">Esta respuesta es <strong>privada</strong>, su respuesta no se muestra en los <strong>resultados</strong></StatusIndicator>
                        )}
                        {question.questionType === "OPTION" && (
                          <FormField
                            info=
                            {question.visibilityQuestion === 0 && (
                              <Box>TEST</Box>
                            )}
                            label={`${index + 1}.- ${question.question}`}
                            description={question.description}
                            constraintText={question.questionParameters.required === 1 ? "Obligatorio" : "Opcional"}
                          >
                            <>
                              {question.questionParameters.minLength <= 1 && question.questionParameters.maxLength === 1 && (
                                <>
                                  <Select
                                    options={
                                      question.questionParameters.minLength === 0
                                        ? [{ label: "-----", value: "" }, ...question.questionParameters.options]
                                        : question.questionParameters.options
                                    }
                                    /* 1. This finds the object in the array that matches the string stored in state */
                                    selectedOption={
                                      question.questionParameters.options.find(
                                        o => o.value === question.answer?.answer
                                      ) || null
                                    }
                                    onChange={({ detail }) => {
                                      // 2. Extract only the .value string from the selected object
                                      const selectedValue = detail.selectedOption.value;

                                      const updatedQuestions = poll.questions.map(q =>
                                        q.idQuestion === question.idQuestion
                                          ? {
                                            ...q,
                                            answer: {
                                              ...(q.answer ?? { idAnswer: 0 }),
                                              /* 3. Store the string value here, not the whole object */
                                              answer: selectedValue
                                            },
                                          }
                                          : q
                                      );
                                      setPoll({ ...poll, questions: updatedQuestions as ItemPollQuestion[] });
                                    }}
                                    placeholder={
                                      Number(question.questionParameters.maxLength) !== 0 || Number(question.questionParameters.minLength) !== 0 ?
                                        Number(question.questionParameters.maxLength) === Number(question.questionParameters.minLength) ?
                                          `Selecciona ${question.questionParameters.maxLength} opción${Number(question.questionParameters.maxLength) > 1 ? "es" : ""}` :
                                          `Selecciona hasta ${question.questionParameters.maxLength} opciones${Number(question.questionParameters.maxLength) > 1 ? "s" : ""}` :
                                        Number(question.questionParameters.minLength) === 0 && Number(question.questionParameters.maxLength) > 0 ?
                                          `Selecciona hasta ${question.questionParameters.maxLength} opciones${Number(question.questionParameters.maxLength) > 1 ? "s" : ""}` :
                                          Number(question.questionParameters.minLength) > 0 && Number(question.questionParameters.maxLength) === 0 ?
                                            `Selecciona al menos ${question.questionParameters.minLength} opciones${Number(question.questionParameters.minLength) > 1 ? "s" : ""}` :
                                            Number(question.questionParameters.minLength) > 0 && Number(question.questionParameters.maxLength) > 0 ?
                                              `Selecciona entre ${question.questionParameters.minLength} y ${question.questionParameters.maxLength} opciones${Number(question.questionParameters.maxLength) > 1 ? "s" : ""}` :
                                              "Selecciona opciones"

                                    }
                                    filteringType="auto"
                                    disabled={false}
                                  />
                                </>
                              )}

                              {question.questionParameters.maxLength > 1 && (
                                <Multiselect
                                  options={question.questionParameters.options}
                                  selectedOptions={
                                    question.answer?.answer
                                      ? question.answer.answer.split(";").map((v: string) => ({ label: v, value: v }))
                                      : []
                                  }
                                  onChange={({ detail }) => {
                                    const newSelected = detail.selectedOptions;

                                    const min = question.questionParameters.minLength;
                                    const max = question.questionParameters.maxLength;

                                    // Allow if within valid range — open side if 0
                                    const isAboveMin = min === 0 || newSelected.length >= min;
                                    const isBelowMax = max === 0 || newSelected.length <= max;

                                    if (isAboveMin && isBelowMax) {
                                      const joinedAnswer = newSelected.map(opt => opt.value).join(";");

                                      const updatedQuestions = poll.questions.map(q =>
                                        q.idQuestion === question.idQuestion
                                          ? {
                                            ...q,
                                            answer: { ...(q.answer ?? { idAnswer: 0 }), answer: joinedAnswer },
                                          }
                                          : q
                                      );

                                      //-----setPoll({ ...poll, questions: updatedQuestions });

                                      setPoll({ ...poll, questions: updatedQuestions as ItemPollQuestion[] });
                                    } else {
                                      // Optionally show warning or prevent update
                                      console.warn(
                                        `⚠️ Selection out of range: ${newSelected.length} (min ${min || "∞"}, max ${max || "∞"})`
                                      );
                                    }
                                  }}

                                  placeholder={
                                    Number(question.questionParameters.maxLength) !== 0 || Number(question.questionParameters.minLength) !== 0 ?
                                      Number(question.questionParameters.maxLength) === Number(question.questionParameters.minLength) ?
                                        `Selecciona ${question.questionParameters.maxLength} opción${Number(question.questionParameters.maxLength) > 1 ? "es" : ""}` :
                                        `Selecciona hasta ${question.questionParameters.maxLength} opciones${Number(question.questionParameters.maxLength) > 1 ? "s" : ""}` :
                                      Number(question.questionParameters.minLength) === 0 && Number(question.questionParameters.maxLength) > 0 ?
                                        `Selecciona hasta ${question.questionParameters.maxLength} opciones${Number(question.questionParameters.maxLength) > 1 ? "s" : ""}` :
                                        Number(question.questionParameters.minLength) > 0 && Number(question.questionParameters.maxLength) === 0 ?
                                          `Selecciona al menos ${question.questionParameters.minLength} opciones${Number(question.questionParameters.minLength) > 1 ? "s" : ""}` :
                                          Number(question.questionParameters.minLength) > 0 && Number(question.questionParameters.maxLength) > 0 ?
                                            `Selecciona entre ${question.questionParameters.minLength} y ${question.questionParameters.maxLength} opciones${Number(question.questionParameters.maxLength) > 1 ? "s" : ""}` :
                                            "Selecciona opciones"

                                  }
                                  filteringType="auto"
                                  tokenLimit={question.questionParameters.maxLength}
                                  disabled={false}
                                />
                              )}
                            </>
                          </FormField>
                        )}

                        {
                          question.questionType == "NUMBER" && (

                            <FormField key={index}
                              label={`${index + 1}.- ${question.question}`}
                              description={question.description} constraintText={question.questionParameters.required === 1 ? "Obligatorio" : "Opcional"}
                              info={
                                question.questionParameters.required === 1 && question.answer.answer === "" ?
                                  <Icon path={mdiAlert} size={1} color={"orange"} /> : undefined
                              }
                            >
                              <Input
                                type="number"
                                value={question.answer?.answer ?? ""}
                                placeholder={
                                  question.questionParameters.minLength || question.questionParameters.maxLength
                                    ? `Entre ${question.questionParameters.minLength || "∞"} y ${question.questionParameters.maxLength || "∞"}`
                                    : "Ingrese un número"
                                }
                                onChange={({ detail }) => {
                                  const newValue = detail.value;

                                  // Parse value as number (empty string allowed)
                                  const numValue = newValue === "" ? 0 : Number(newValue);

                                  // Enforce numeric range if defined
                                  const min = question.questionParameters.minLength;
                                  const max = question.questionParameters.maxLength;

                                  const validMin = min > 0 ? numValue >= min : true;
                                  const validMax = max > 0 ? numValue <= max : true;

                                  if (numValue === 0 || (validMin && validMax)) {
                                    const updatedQuestions = poll.questions.map(q => {
                                      if (q.idQuestion === question.idQuestion) {
                                        return {
                                          ...q,
                                          answer: {
                                            ...(q.answer ?? { idAnswer: 0 }),
                                            answer: newValue,
                                          },
                                        };
                                      }
                                      return q;
                                    });

                                    setPoll({ ...poll, questions: updatedQuestions as ItemPollQuestion[] });
                                    //-----const updatedPoll: ItemPoll = {...poll, questions: updatedQuestions,};
                                    //-----setPoll(updatedPoll);
                                  }
                                }}
                              />
                            </FormField>
                          )
                        }
                        {
                          question.questionType == "TEXT" && (

                            <FormField key={index}
                              label={`${index + 1}.- ${question.question}`}
                              description={question.description}
                              constraintText={<>
                                {question.questionParameters.required === 1 ? "Obligatorio" : "Opcional"}{" "}{question.questionParameters.required === 1 && question.answer.answer === "" ?
                                  <Icon path={mdiAlert} size={0.75} color={"orange"} /> : undefined
                                }
                              </>
                              }
                            >
                              <Input
                                value={poll.questions.find(q => q.idQuestion === question.idQuestion)?.answer?.answer ?? ""}
                                onChange={({ detail }) => {
                                  const newValue = detail.value;

                                  const updatedQuestions = poll.questions.map(q => {
                                    if (q.idQuestion === question.idQuestion) {
                                      return {
                                        ...q,
                                        answer: {
                                          ...(q.answer ?? { idAnswer: 0 }),
                                          answer: newValue,
                                        },
                                      };
                                    }
                                    return q;
                                  });

                                  setPoll({ ...poll, questions: updatedQuestions as ItemPollQuestion[] });
                                  //-----const updatedPoll: ItemPoll = {...poll, questions: updatedQuestions};
                                  //-----setPoll(updatedPoll);
                                }}
                                placeholder="Escribe tu respuesta"
                              />
                            </FormField >

                          )
                        }
                        {question.visibilityQuestion === 0 && (
                          <Checkbox checked={question.answer.visibilityAnswer === -1} onChange={(e) => {
                            const newValue = e.detail.checked ? -1 : 1;

                            const updatedQuestions = poll.questions.map(q => {
                              if (q.idQuestion === question.idQuestion) {
                                return {
                                  ...q,
                                  answer: {
                                    ...(q.answer ?? { idAnswer: 0 }),
                                    visibilityAnswer: newValue,
                                  },
                                };
                              }
                              return q;
                            });

                            setPoll({ ...poll, questions: updatedQuestions as ItemPollQuestion[] });
                            //-----const updatedPoll: ItemPoll = {...poll,questions: updatedQuestions};
                            //-----setPoll(updatedPoll);

                          }}> Marcar como privada la respuesta
                          </Checkbox>
                        )}
                      </Container>
                    ))}


                    {isValidAnswers.isValid === false && (
                      <Alert
                        type="error"
                        header="Corregir respuestas"
                      >
                        <SpaceBetween direction="vertical" size="xs">
                          <List
                            disableItemPaddings
                            items={isValidAnswers.errors.map((err, index) => ({
                              id: index.toString(),
                              content: err.message
                            }))}
                            renderItem={(item: any) => item}
                          />

                        </SpaceBetween>
                      </Alert>
                    )}
                  </SpaceBetween>


                </Form>
              )}
            </SpaceBetween>
          )}

          {!poll && pollsActual && pollsActual.length === 0 && (
            <SpaceBetween size="l">
              {pollsActual.length === 0 && (<>
                <Alert type="info" header="No hay inscripciones activas" dismissible={false}>
                  Actualmente no hay inscripciones activas para participar. Por favor, revisa más tarde.
                </Alert>
              </>)}
            </SpaceBetween>
          )}

          {!poll && pollsActual && pollsActual.length > 0 && (
            <>

              <ExpandableSection headerText={`Abiertas (${pollsActual.length})`} variant="default" defaultExpanded={true} expanded>
                <Cards
                  cardDefinition={{
                    sections: [
                      {
                        id: "status",
                        header: "",
                        content: item =>
                          <div className="card-content-wrapper" style={{}}>
                            <div className="card-body-text" style={{}}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', gap: '12px' }}>
                                {/* Left side: Takes remaining space, wraps text cleanly */}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <Header variant="h1">
                                    <Link href={`#members/etc/polls?id=${item.idPoll}`} fontSize="heading-m">
                                      {item.poll}
                                    </Link>
                                  </Header>
                                </div>

                                {/* Right side: Fixed to 1 line, never shrinks or wraps */}
                                <div style={{ flexShrink: 0 }}>
                                  {
                                    item.hasStarted === 0 ? <BadgeCustom bold={false} color="grey">Próximamente</BadgeCustom> :
                                      item.hasStarted === 1 && item.hasEnded === 0 ? <BadgeCustom color="lime" bold={false}>En desarrollo</BadgeCustom> :
                                        item.hasStarted === 1 && item.hasEnded === 1 ? <BadgeCustom color="purple" bold={false}>Finalizada</BadgeCustom> : null
                                  }
                                </div>
                              </div>
                              <FormField label="Fecha de cierre">
                                {`${item.dateClose} a las ${item.timeClose}`}
                              </FormField>

                              <FormField label={getPollTypeTitle(item.pollType)}>
                                {item.publicResults === 0 ? "Privado" : item.totalUsers === 0 ? "Sin inscritos" : `Inscrito${item.totalUsers > 1 ? "s" : ""}: ${item.totalUsers} ${item.answers.find(a => a.idUser === idUser) ? "(Tú estás inscrito)" : ""}`}
                              </FormField>

                            </div>
                            <div className="card-actions">

                              {(item.answers.find(a => a.idUser === idUser) || item.totalUsers > 0) && (
                                <SpaceBetween direction="vertical" size="xs">
                                  <HorizontalRule />
                                  <Box>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                      <div>
                                        {
                                          item.totalUsers === 0 ? "" : <Button href={`#members/etc/polls.answers?id=${item.idPoll}`}>Respuestas</Button>
                                        }
                                      </div>
                                      <div>
                                        <SpaceBetween direction="horizontal" size="xs">
                                          {
                                            item.answers.find(a => a.idUser === idUser) && item.userCanDeleteRegistration === 1 ? <Button style={{ root: btnWarn }}
                                              onClick={() => {
                                                setPollDelete(item)

                                              }}>Eliminar mi registro</Button> : null
                                          }
                                          {
                                            item.hasStarted === 1 && item.hasEnded === 0 && item.isActivePoll === 1 && item.userCanAnswer === 1 && (
                                              <Button variant='primary' href={`#members/etc/polls?id=${item.idPoll}`}>{item.answers.find(a => a.idUser === idUser) ? "Modificar" : "Responder"}</Button>

                                            )
                                          }
                                        </SpaceBetween>
                                      </div>
                                    </div>
                                  </Box>
                                </SpaceBetween>
                              )}
                            </div>
                          </div>
                      },
                    ]
                  }}
                  cardsPerRow={[
                    { cards: 1 },
                    { minWidth: 1000, cards: 2 },
                  ]}
                  items={pollsActual}
                  loadingText="Cargando inscripciones"
                  stickyHeader
                  variant="container"
                  empty={
                    <Box
                      margin={{ vertical: "xs" }}
                      textAlign="center"
                      color="inherit"
                    >
                      <SpaceBetween size="m">
                        <b>No resources</b>
                        <Button>Create resource</Button>
                      </SpaceBetween>
                    </Box>
                  }
                />
              </ExpandableSection>
            </>
          )
          }


          {
            !poll && pollsFuture && pollsFuture.length > 0 && (
              <>
                <Header variant='h2'>
                  Próximamente
                </Header>
                <Box>
                  <Cards
                    cardDefinition={{
                      header: item => (
                        <Header
                          actions={
                            item.hasStarted === 0 ? <BadgeCustom color="grey">Próximamente</BadgeCustom> :
                              item.hasStarted === 1 && item.hasEnded === 0 ? <BadgeCustom color="lime">En desarrollo</BadgeCustom> :
                                item.hasStarted === 1 && item.hasEnded === 1 ? <BadgeCustom color="purple">Finalizada</BadgeCustom> : ""
                          }
                        ><Link href={`#members/etc/polls?id=${item.idPoll}`} fontSize="heading-m">
                            {item.poll}
                          </Link></Header>
                      ),
                      sections: [
                        {
                          id: "description",
                          header: "Descripción",
                          content: item => item.description.length > 80 ? item.description.substring(0, 80) + "…" : item.description
                        },
                        {
                          id: "status",
                          header: "",
                          content: item =>

                            <SpaceBetween direction="horizontal" size="xs">
                              <div key={item.idPoll}>
                                <FormField label="Fecha de apertura">
                                  {`${item.dateOpen} a las ${item.timeOpen}`}
                                </FormField>

                                <FormField label={getPollTypeTitle(item.pollType)}
                                  constraintText={
                                    item.publicAnswers === 0 ? "" : item.totalUsers === 0 ? "" : <Link href={`#members/etc/polls.answers?id=${item.idPoll}`}><small>Ver respuestas</small></Link>
                                  }
                                >
                                  {item.publicResults === 0 ? "Privado" : item.totalUsers === 0 ? "Sin inscritos" : `Inscrito${item.totalUsers > 1 ? "s" : ""}: ${item.totalUsers}`}
                                </FormField>
                              </div>
                            </SpaceBetween>
                        },
                      ]
                    }}
                    cardsPerRow={[
                      { cards: 1 },
                      { minWidth: 1000, cards: 2 },
                    ]}
                    items={pollsFuture}
                    loadingText="Cargando inscripciones"
                    stickyHeader
                    variant="full-page"
                    empty={
                      <Box
                        margin={{ vertical: "xs" }}
                        textAlign="center"
                        color="inherit"
                      >
                        <SpaceBetween size="m">
                          <b>No resources</b>
                          <Button>Create resource</Button>
                        </SpaceBetween>
                      </Box>
                    }
                  />
                </Box>
              </>
            )
          }
          {
            !poll && pollsPrev && pollsPrev.length > 0 && (
              <>
                <ExpandableSection headerText={`Finalizadas (${pollsPrev.length})`} variant="default" defaultExpanded={false}>

                  <Cards
                    cardDefinition={{
                      header: item => (
                        <Header
                          actions={
                            item.hasStarted === 0 ? <BadgeCustom color="grey">Próximamente</BadgeCustom> :
                              item.hasStarted === 1 && item.hasEnded === 0 ? <BadgeCustom color="lime">En desarrollo</BadgeCustom> :
                                item.hasStarted === 1 && item.hasEnded === 1 ? <BadgeCustom color="purple">Finalizada</BadgeCustom> : ""
                          }
                        ><Link href={`#members/etc/polls?id=${item.idPoll}`} fontSize="heading-m">
                            {item.poll}
                          </Link></Header>
                      ),
                      sections: [
                        {
                          id: "description",
                          header: "Descripción",
                          content: item => item.description.length > 80 ? item.description.substring(0, 80) + "…" : item.description
                        },
                        {
                          id: "status",
                          header: "",
                          content: item =>

                            <SpaceBetween direction="horizontal" size="xs">
                              <div key={item.idPoll}>
                                <FormField label="Fecha de cierre">
                                  {`${item.dateClose} a las ${item.timeClose}`}
                                </FormField>

                                <FormField label="Inscripciones"
                                  constraintText={
                                    item.publicAnswers === 0 ? "" : item.totalUsers === 0 ? "" : <Link href={`#members/etc/polls.answers?id=${item.idPoll}`}><small>Ver respuestas</small></Link>
                                  }
                                >
                                  {item.publicResults === 0 ? "Privado" : item.totalUsers === 0 ? "Sin inscritos" : `Inscrito${item.totalUsers > 1 ? "s" : ""}: ${item.totalUsers}`}
                                </FormField>
                              </div>
                            </SpaceBetween>
                        },
                      ]
                    }}
                    cardsPerRow={[
                      { cards: 1 },
                      { minWidth: 1000, cards: 2 },
                    ]}
                    items={pollsPrev}
                    loadingText="Cargando inscripciones"
                    stickyHeader
                    variant="full-page"
                    empty={
                      <Box
                        margin={{ vertical: "xs" }}
                        textAlign="center"
                        color="inherit"
                      >
                        <SpaceBetween size="m">
                          <b>No resources</b>
                          <Button>Create resource</Button>
                        </SpaceBetween>
                      </Box>
                    }
                  />
                </ExpandableSection>
              </>
            )
          }
          <Confirm type={"warning"} show={!!pollDelete} action={'Eliminar'} warning={'¿Desea eliminar sus respuesta e incripción?'} onDismiss={() => setPollDelete(undefined)}
            onConfirm={() => {
              handleDeleteAnswers(pollDelete.idPoll)
            }}
          />
        </SpaceBetween >
      }
    />
  );
};
